import { Role } from '../../types'

export const canViewExecutiveMetrics = (role: Role) => role === Role.ejecutivo
export const executiveMetricsRouteForRole = (role: Role) =>
  canViewExecutiveMetrics(role) ? { name: 'Métricas', route: '/executive-metrics' } : null
export const EXECUTIVE_METRICS_BLOCKED_ROLES = Object.values(Role).filter(role => role !== Role.ejecutivo)
export { bogotaPeriod } from '../agentMetrics/utils'
